import _ from 'underscore';
import DEMAND_CLASSES from '../../modules/demand_classes.js';

angular.module('vastdesk').
  component('formatFields',  {
    bindings: {
      formName: '@',
      formId: '@',
      format: '@',
      persisted: '<',
      formatOptions: '<',
      allFormatOptions: '<',
      demandClass: '@',
      customResponse: '<',
      tileTagDemandClass: '<',
      progTilesEnabled: '<',
      bidPlatform: '@',
      tileFormatBidPlatforms: '<',
      pauseAdFormatBidPlatforms: '<'
    },
    template: require("../templates/formatFields.html"),
    controllerAs: '$formatFieldsCtrl',
    controller: ['$rootScope', '$scope', function($rootScope, $scope) {

      var self = this;

      this.setFormat = function(format) {
        if (self.formatDisabled(format)) {
          return;
        }
        self.format = format;

        showHideFormatElements();

        $rootScope.$broadcast('formatChanged', {
          format: format
        });
      };

      // Should always match Ruby `DemandTag#tile_format_allowed?`
      const tileCompatibleDemandClass = () => {
        const demandClasses = [
          DEMAND_CLASSES.CLASS_CREATIVE_ASSET,
          DEMAND_CLASSES.CLASS_HOUSE_AD,
          DEMAND_CLASSES.CLASS_LINE_ITEM,
          DEMAND_CLASSES.CLASS_DIRECT_IO_LINE_ITEM
        ];

        if (this.tileTagDemandClass) {
          demandClasses.push(DEMAND_CLASSES.CLASS_TAG);
        }

        if (this.progTilesEnabled) {
          demandClasses.push(DEMAND_CLASSES.CLASS_HEADER_BIDDING);
        }

        return _.includes(demandClasses, this.demandClass);
      };

      // Audio is only valid when NOT HB.
      const isHeaderBidding = (demandClass) => {
        return demandClass === DEMAND_CLASSES.CLASS_HEADER_BIDDING;
      };

      // Should match Ruby HeaderBiddingPlatformService#supports_*_format?
      const formatSupportedForBidPlatform = (format) => {
        if (!isHeaderBidding(self.demandClass) || !self.bidPlatform) {
          return true;
        }

        if (format === 'tile') {
          return _.includes(self.tileFormatBidPlatforms, self.bidPlatform);
        }

        if (format === 'pause_ad') {
          return _.includes(self.pauseAdFormatBidPlatforms, self.bidPlatform);
        }

        return true;
      };

      this.formatDisabled = function(format) {
        if (self.persisted) {
          return true;
        }

        if (self.formatOptions.length === 1) {
          return false;
        }

        const isTileOrPauseAd = ['tile', 'pause_ad'].includes(format);
        const isTileOrPauseAdDisabled = isTileOrPauseAd && (
          (self.demandClass && !tileCompatibleDemandClass()) ||
          !formatSupportedForBidPlatform(format)
        );

        return (format === 'audio' && isHeaderBidding(self.demandClass)) ||
          isTileOrPauseAdDisabled ||
          (_.includes([DEMAND_CLASSES.CLASS_DIRECT_CONNECT, DEMAND_CLASSES.CLASS_OPEN_RTB_DIRECT_CONNECT], self.demandClass));
      };

      this.checkboxCb = function(val) {
        $rootScope.$broadcast('customResponseChanged', {
          customResponse: val
        });
      };

      // "Custom Response" is intentionally omitted from "Pause Ad" format
      this.showCustomResponse = function() {
        return self.format === 'tile' && _.includes(['supply_tag', 'supply_router'], self.formName);
      };

      $scope.$on('demandClassChanged', function(e, args) {
        self.demandClass = args.demandClass;
      });

      $scope.$on('bidPlatformChange', function(e, args) {
        self.bidPlatform = args.bidPlatform;
      });

      var showHideElement = function(format, shownSuffix, disabledSuffix) {
        $('.' + format + '-shown' + shownSuffix).toggleClass('hidden', format !== self.format);
        $('.' + format + '-disabled' + disabledSuffix).attr('disabled', format === self.format);
      };

      var showHideFormatElements = function() {
        _.each(self.allFormatOptions, function(formatOption) {
          var shownSuffix = '';
          var disabledSuffix = '';

          if (formatOption[1] !== self.format) {
            shownSuffix = ':not(.' + self.format + '-shown)';
            disabledSuffix = ':not(.' + self.format + '-disabled)';
          }

          showHideElement(formatOption[1], shownSuffix, disabledSuffix);
        });
      };

      this.$onInit = function() {
        showHideFormatElements();
      };

    }]
});
